import axiosInstance from "@/config/axios";
import { emptyPaymentDelivery, PAYMENT_DELIVERY_EMPTY } from "@/config/sellerProfile/paymentDeliveryCompleteness";
import { emptyStoreInfo, STORE_INFO_EMPTY } from "@/config/sellerProfile/storeInfoCompleteness";

const PAYMENT_DELIVERY_URL = "/v1/seller-profile/payment-delivery";
const STORE_INFO_URL = "/v1/seller-profile/store-info";
const COMPLETENESS_URL = "/v1/seller-profile/completeness";

function mergeSection(emptyPayloads, sectionId, section) {
    const emptyPayload = emptyPayloads[sectionId]?.() || {};

    return {
        payload: { ...emptyPayload, ...(section?.payload || {}) },
        isComplete: Boolean(section?.isComplete),
    };
}

function mergeProfile(emptyFactory, emptyPayloads, raw) {
    const empty = emptyFactory();

    if (!raw || typeof raw !== "object") {
        return empty;
    }

    return Object.fromEntries(
        Object.entries(empty).map(([sectionId, defaults]) => [
            sectionId,
            mergeSection(emptyPayloads, sectionId, raw[sectionId] || defaults),
        ])
    );
}

export async function getPaymentDelivery(shopId) {
    if (!shopId) {
        return emptyPaymentDelivery();
    }

    const { data } = await axiosInstance.get(PAYMENT_DELIVERY_URL);

    return mergeProfile(emptyPaymentDelivery, PAYMENT_DELIVERY_EMPTY, data);
}

export async function getStoreInfo(shopId) {
    if (!shopId) {
        return emptyStoreInfo();
    }

    const { data } = await axiosInstance.get(STORE_INFO_URL);

    return mergeProfile(emptyStoreInfo, STORE_INFO_EMPTY, data);
}

export async function getCompleteness(shopId) {
    if (!shopId) {
        return {
            sections: {},
            completeCount: 0,
            totalSlots: 0,
            paymentDeliveryComplete: false,
            storeInfoComplete: false,
        };
    }

    const { data } = await axiosInstance.get(COMPLETENESS_URL);

    return data;
}

export async function updateSection(shopId, sectionId, payload) {
    if (!shopId) {
        throw new Error("No shop selected");
    }

    const { data } = await axiosInstance.put(`${PAYMENT_DELIVERY_URL}/${sectionId}`, payload);

    return mergeSection(PAYMENT_DELIVERY_EMPTY, sectionId, data);
}

export async function updateStoreInfoSection(shopId, sectionId, payload) {
    if (!shopId) {
        throw new Error("No shop selected");
    }

    const { data } = await axiosInstance.put(`${STORE_INFO_URL}/${sectionId}`, payload);

    return mergeSection(STORE_INFO_EMPTY, sectionId, data);
}
